import React from 'react';
import { 
  generateCustomerPDF, 
  generateCustomerPreOrderPDF, 
  generateWorkshopPDF, 
  generateInstallationPDF, 
  generateFirmaPDF 
} from '../../../utils/pdfGenerators';

const OrderDetailsPDF = ({
  customerInfo,
  orders,
  totalAmount,
  discountedTotalAmount,
  genelIskontoYuzde,
  vadeliYuzde,
  paidAmount,
  remainingAmount
}) => {
  return (
    <div className="pdf-buttons-section">
      <div className="pdf-buttons">
        <button
          onClick={() => generateCustomerPreOrderPDF(customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde)}
          className="pdf-btn customer-pdf"
          title="Müşteri (Sipariş öncesi) PDF oluştur"
        >
          <i className="fas fa-file-pdf"></i>
          <span>Müşteri (Sipariş öncesi)</span>
        </button>
        <button
          onClick={() => generateCustomerPDF(customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, parseFloat(paidAmount) || 0, remainingAmount)}
          className="pdf-btn customer-pdf"
          title="Müşteri için PDF oluştur"
        >
          <i className="fas fa-file-pdf"></i>
          <span>Müşteri</span>
        </button>
        <button
          onClick={() => generateFirmaPDF(customerInfo, orders)}
          className="pdf-btn firma-pdf"
          title="Firma için PDF oluştur"
        >
          <i className="fas fa-file-pdf"></i>
          <span>Firma</span>
        </button>
        <button
          onClick={() => generateWorkshopPDF(customerInfo, orders)}
          className="pdf-btn workshop-pdf"
          title="Atölye için PDF oluştur"
        >
          <i className="fas fa-file-pdf"></i>
          <span>Atölye</span>
        </button>
        <button
          onClick={() => generateInstallationPDF(customerInfo, orders)}
          className="pdf-btn installation-pdf"
          title="Montaj için PDF oluştur"
        >
          <i className="fas fa-file-pdf"></i>
          <span>Montaj</span>
        </button>
      </div>
    </div>
  );
};

export default OrderDetailsPDF;
